export default "__VITE_ASSET__D$W_NUPw__"